module.exports = __webpack_public_path__ + "static/media/view4.74b0a143.jpg";